import React from 'react';

const ProfileInfo = ({ user }) => {
  if (!user) return <div>Loading...</div>;

  const fields = [
    { label: 'Name',         value: user.name },
    { label: 'Email',        value: user.email },
    { label: 'Phone',        value: user.phone ? `${user.phone_code ? user.phone_code + ' ' : ''}${user.phone}` : null },
    { label: 'Gender',       value: user.gender },
    { label: 'Date of Birth',value: user.dob },
    { label: 'Registered',   value: user.createdAt ? new Date(user.createdAt).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : null },
  ];

  return (
    <div className="card">
      <div className="card-header border-0 pt-6">
        <h3 className="card-title fw-bold m-0">Personal Info</h3>
      </div>
      <div className="card-body pt-4">
        <div className="row">
          {fields.map(({ label, value }) => (
            <div key={label} className="col-md-6 mb-6">
              <label className="text-gray-500 fw-semibold fs-7 mb-1 d-block">{label}</label>
              <div className="text-gray-800 fw-semibold fs-6">{value || 'N/A'}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
